var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-dropdown-child",class:{ active: _vm.active, noHover: _vm.noHover, rtl: _vm.rtl, between: _vm.between },on:{"click":_vm.close}},[(_vm.icon)?_c('r-icon',{attrs:{"name":_vm.icon,"size":22}}):_vm._e(),_c('div',{staticClass:"r-dropdown-child__content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }